import { selectIsLoading, selectIsLoggedIn, selectUser } from 'containers/Login/loginSlice'
import { ACCOUNT_TYPE } from 'containers/Account/accountSlice'
import { useHistory, useParams } from 'react-router-dom'
import Sections from 'containers/Account/Sections'
import useTranslation from 'hooks/useTranslation'
import Popups from 'containers/Account/Popups'
import { displayPrice } from 'utils/string'
import { useSelector } from 'react-redux'
import { useLayoutEffect } from 'react'
import './style.scss'

const Account = () => {
  const user = useSelector(selectUser)
  const isLogin = useSelector(selectIsLoggedIn)
  const isLoading = useSelector(selectIsLoading)
  const userHasUnpaidInvoices = Array.isArray(user?.unpaid_invoices) && user.unpaid_invoices.length > 0
  const { key } = useParams()

  const { push, replace } = useHistory()
  const { t } = useTranslation('account')
  const goTo = route => { push(`/account/${route}`) }

  useLayoutEffect(() => {
    if (!isLogin && !isLoading && key !== ACCOUNT_TYPE.settings) replace('/login')
  }, [isLoading, isLogin, key, replace])

  return (
    <>
      <div className='desktopAccount account'>
        <div className='title left'>
          <div>{t('customerPanel')}</div>
          <div className='group'>
            <span>{t('subTitle')}</span>
          </div>
        </div>
        <div className="desktopAccount__wrap">
          <div className="item" onClick={() => goTo(ACCOUNT_TYPE.basic)}>
            <i className="icon s32 icon--user"></i>
            <span>{t('yourData')}</span>
          </div>
          <div className="item" onClick={() => goTo(ACCOUNT_TYPE.company)}>
            <i className="icon s32 icon--company"></i>
            <span>{t('companies')}</span>
          </div>
          <div className="item" onClick={() => goTo(ACCOUNT_TYPE.invoices)}>
            <div className='item__icon'>
              <i className="icon s32 icon--invoices"></i>
              {userHasUnpaidInvoices && <div className='item__icon__additional'>{user.unpaid_invoices.length}</div>}
            </div>
            <span>{t('invoices')}</span>
          </div>
          <div className="item" onClick={() => goTo(ACCOUNT_TYPE.share)}>
            <i className="icon s32 icon--share"></i>
            <span>{t('shares')}</span>
          </div>
          <div className="item" onClick={() => goTo(ACCOUNT_TYPE.payments)}>
            <i className="icon s32 icon--payments"></i>
            <span>{t('payments')}{user?.unpaidInvoicesAmount ? ` (${displayPrice(user.unpaidInvoicesAmount)})` : ''}</span>
          </div>

        </div>
        <Sections />
        <Popups />
      </div>
    </>
  )
}

export default Account